import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

export interface ColoredTag {
    label: string;
    color: string;
}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-detail-tags',
    templateUrl: './detail-tags.component.html',
    styleUrls: ['./detail-tags.component.scss'],
    standalone: false,
})
export class DetailTagsComponent {
    @Input()
    public title?: string;

    @Input()
    public ariaLabel?: string;

    @Input()
    public tags?: Array<string | ColoredTag>;

    @Input()
    public rightAligned?: boolean;
}
